






























import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { Portion } from '@/models'

@Component({
  components: {
    ListItem
  }
})
export default class PortionTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly portion!: Portion

  @Prop({ type: Number, required: true })
  readonly itemId!: number

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number
}
